import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ChallengeShowPage } from '../ChallengeShowPage'
import { routes as adminRoutes } from '../admin/AdminApp'
import { ChallengeMap } from '../ChallengeMap'
import { UserChallenges } from 'features/homepage/Challenges'
import { SideNavLayout } from 'common/layouts/SideNavLayout'

export const routes = [
  <Route key='challenges' path='/challenges' exact component={UserChallenges} />,
  <Route key='challengesId' path='/challenges/:challengeId'>
    <Switch>
      <Route path='/challenges/:challengeId' exact>
        <SideNavLayout greyBg>
          <ChallengeShowPage />
        </SideNavLayout >
      </Route>
      <Route path='/challenges/:challengeId/route_map' component={ChallengeMap} />
      {adminRoutes}
    </Switch>
  </Route>
]
